<template>
  <div class="suggestion_business">
    <div class="suggestion_header">
      <img src="../assets/images/arrow-b.svg" @click="$router.go(-1)" />
    </div>
    <div class="suggestion_mid_container">
      <div class="title_block">
        <h2>{{$t('Makeasuggestion')}} ({{$t('Suggestandedit')}})</h2>
        <p>{{$t('Helpwithyoursuggestion')}}</p>
      </div>
      <form @submit.prevent="submit" novalidate class="fill_business_detail">
        <div class="business_form_block">
          <div class="business_block">
            <business-name-field v-model="form.businessName" :v="$v.form.businessName" />
          </div>
          <div class="business_block">
            <category-field v-model="form.categoryName" :v="$v.form.categoryName" />
          </div>
          <div class="business_block">
            <address-field v-model="form.addressName" :v="$v.form.addressName" />
          </div>
          <div class="form_detail">
            <div class="address_detail">
              <pincode-field v-model="form.pincode" :v="$v.form.pincode" />
            </div>
            <div class="address_detail">
              <label for="business_name">{{$t('postOffice')}}</label>
              <input type="text" name="business" :placeholder="$t('postOffice')" />
            </div>
          </div>
          <div class="form_detail">
            <div class="address_detail">
              <city-field v-model="form.cityName" :v="$v.form.cityName" />
            </div>
            <div class="address_detail">
              <state-field v-model="form.stateName" :v="$v.form.stateName" />
            </div>
          </div>
          <div class="business_block">
            <mobile-field v-model="form.mobileNo" :v="$v.form.mobileNo" />
          </div>
        </div>
        <div class="add_photo_block">
          <h3>{{$t('Addnewphoto')}}</h3>
          <div class="photo_upload_sec">
            <div class="photo_section">
              <span class="upload-icon">
                <img :src="form.addShopPhoto" v-if="form.addShopPhoto" />
                <img src="../assets/images/default-image.svg" v-else />
              </span>
              <p class="upload_photo_text">{{$t('earnMpoints')}}</p>
              <add-shop-photo v-model="form.addShopPhoto" @photoEmit="previewPhoto" />
            </div>
          </div>
        </div>
        <p class="advice_text">{{$t('warning')}}</p>
        <div class="suggestion_submit_button">
          <Button
            :btn_txt="$t('submit')"
            btn_cls="submitBtn"
            :class="{'isDisable' : isDisable}"
            :disabled="isDisable"
          />
        </div>
      </form>
    </div>
    <div class="loader" v-if="loading">
      <img src="../assets/images/gif-loader.gif" />
    </div>
  </div>
</template>
<script>
import { toaster } from "../utils/helper";
import { mapState } from "vuex";
import axios from "axios";
import { FILE_UPLOAD_URL } from "../utils/constant";
import Button from "../components/common/Button";
import { required } from "vuelidate/lib/validators";
import types from "../store/types";
import { isName, isPinCodeNumber, isMobileNumber } from "../utils/validators";
import BusinessNameField from "../components/inputfield/BusinessNameField";
import CategoryField from "../components/inputfield/CategoryField";
import AddressField from "../components/inputfield/AddressField";
import CityField from "../components/inputfield/CityField";
import PincodeField from "../components/inputfield/PincodeField";
import StateField from "../components/inputfield/StateField";
import MobileField from "../components/inputfield/MobileField";
import AddShopPhoto from "../components/inputfield/AddShopPhoto";
import VueCookie from "vue-cookie";
import Vue from "vue";
Vue.use(VueCookie);
export default {
  name: "SuggestInEditBusiness",
  components: {
    Button,
    BusinessNameField,
    CategoryField,
    AddressField,
    CityField,
    PincodeField,
    StateField,
    MobileField,
    AddShopPhoto
  },
  computed: {
    ...mapState(["category", "edisBusiness"])
  },
  data() {
    return {
      form: {
        businessName: "",
        categoryName: "",
        addressName: "",
        cityName: "",
        pincode: "",
        stateName: "",
        mobileNo: "",
        addShopPhoto: ""
      },
      isDisable: false,
      loading: false
    };
  },
  validations: {
    form: {
      businessName: { required, isBusiness: isName },
      categoryName: { required },
      addressName: { required },
      cityName: { required, isCity: isName },
      pincode: { required, isPincode: isPinCodeNumber },
      stateName: { required, isState: isName },
      mobileNo: { required, isMobile: isMobileNumber },
      addShopPhoto: { required }
    }
  },
  methods: {
    previewPhoto(photofile) {
      this.form.addShopPhoto = photofile;
    },
    submit() {
      this.isDisable = true;
      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) {
        this.isDisable = false;
        return;
      }
      this.loading = true;
      var businessdetail = {
        businessName: this.form.businessName,
        cType: this.form.categoryName,
        address: this.form.addressName,
        city: this.form.cityName,
        mobileNo: this.form.mobileNo,
        pincode: this.form.pincode,
        addShopPhoto: this.form.addShopPhoto,
        stateName :this.form.stateName,
        long: VueCookie.get("longitude"),
        lat: VueCookie.get("latitude"),
        business_id: this.edisBusiness.id
      };
      this.$store.commit("ADDBUSINESS", businessdetail);
      this.$store
        .dispatch({ type: "postBusiness", payload: businessdetail })
        .then(data => {
          if (data.status == "Success") {
            this.loading = false;
            this.isDisable = false;
            this.$store.commit(types.LOADBUSINESS, []);
            this.$router.go(-1);
          }
        })
        .catch(err => {
          toaster(
            this,
            this.$t("wentWrong"),
            "top-center",
            2000
          );
        });
    }
  },
  mounted() {
    this.form.businessName = this.edisBusiness.business_name;
    this.form.categoryName = this.edisBusiness.cType;
    this.form.addressName = this.edisBusiness.address.street;
    this.form.cityName = this.edisBusiness.address.city;
    this.form.pincode = this.edisBusiness.address.zip_code;
    this.form.stateName = this.edisBusiness.address.state;
  }
};
</script>
